import { MediaServer } from "@/configs";

export function getMediaFullPath(media: string): string {
  if (media.startsWith("http://") || media.startsWith("https://")) {
    return media;
  }
  return `${MediaServer}/${media}`;
}
